import React, { useState, useEffect } from 'react'
// import { MediaControlBarRoot, MediaControlBar } from '../media'
import { LayoutContext } from '../../utils/contexts'

/** Bootstrap `lg` — matches sidebar.scss `@media (min-width: 992px)`. */
const LG_MIN_WIDTH = 992

const getIsLgScreen = () =>
  typeof window !== 'undefined' && window.innerWidth >= LG_MIN_WIDTH

const MediaControlWrapper = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(getIsLgScreen)
  const [showPlayBar, setShowPlayBar] = useState(false)
  const [minimizePlayBar, setMinimizePlayBar] = useState(false)
  const [mediaObject, setMediaObject] = useState(null)

  // DevTools device mode / window resize: reopen gnav when entering desktop,
  // close the mobile drawer when leaving it. Do not fight manual toggles while
  // staying on the same side of the breakpoint.
  useEffect(() => {
    let wasLg = getIsLgScreen()

    const onResize = () => {
      const isLg = getIsLgScreen()
      if (isLg === wasLg) {
        return
      }
      wasLg = isLg
      setShowSidebar(isLg)
    }

    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return (
    <LayoutContext.Provider
      value={{
        setShowSidebar: (isSidebarVisible) => setShowSidebar(isSidebarVisible),
        showSidebar: showSidebar,
        showPlayBar: showPlayBar,
        setShowPlayBar: (isPlayBarVisible) => setShowPlayBar(isPlayBarVisible),
        minimizePlayBar: minimizePlayBar,
        setMinimizePlayBar: (isMinimize) => setMinimizePlayBar(isMinimize),
        mediaObject: mediaObject,
        setMediaObject: (obj) => setMediaObject(obj),
      }}>
      <div>
        {children}
        {/* <MediaControlBarRoot>
          <MediaControlBar />
        </MediaControlBarRoot> */}
      </div>
    </LayoutContext.Provider>
  )
}

export default MediaControlWrapper
